import { memo } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import "./ItineraryViewRecap.scss";
import isEmpty from "lodash/isEmpty";
import TimelineInfoRecap from "app/pages/Booking/Quotation/Flight/SelectedFlightRecap/TimelineInfoRecap";
import { ITINERARY_INFO_TYPE } from "app/constants";
import LoaderBar from "app/pages/.shared/LoaderBar/LoaderBar";

const groupEvents = events => {
	const groupedEvents = [];
	let tempGroup = [];

	// Ajouter le tempGroup au tableau groupedEvents et réinitialise tempGroup.
	const pushTempGroup = () => {
		if (tempGroup.length) {
			groupedEvents.push([...tempGroup]);
			tempGroup = [];
		}
	};

	// Itérer sur chaque événement et les grouper en fonction de leur type.
	events.forEach(event => {
		if (event.type === ITINERARY_INFO_TYPE.STOPOVER_INFO) {
			// Ajouter les événements de type STOPOVER_INFO directement à groupedEvents.
			pushTempGroup();
			groupedEvents.push([event]);
		} else {
			tempGroup.push(event);
			// Si le groupe temporaire a 3 événements, finalise le groupe.
			if (tempGroup.length === 3) {
				pushTempGroup();
			}
		}
	});

	// Ajouter les événements restants dans le groupe temporaire à groupedEvents.
	pushTempGroup();
	return groupedEvents;
};

const ItineraryViewRecap = ({ label, flightData = [] }) => {
	const groupedFlightData = groupEvents(flightData);
	const isDataReady = label && flightData.length > 0;
	return (
		<div className="itinerary-view-recap">
			<div className="itinerary-view-recap__flight-label">
				{isDataReady ? (
					<Typography variant={TYPOGRAPHY_VARIANTS.SMALL} isBold>
						<FormattedMessage id={label} />
					</Typography>
				) : (
					<LoaderBar height={10} width={110} />
				)}
			</div>
			{!isDataReady && (
				<div className="itinerary-view-recap__itinerary--timeline itinerary-view-recap__itinerary--timeline-loader">
					<div className="itinerary-recap-timeline__group" key="1">
						<div className="itinerary-recap-timeline__schedule">
							<div className="itinerary-recap-timeline__schedule-airport">
								<LoaderBar height={9} width={60} />
							</div>
							<div className="itinerary-recap-timeline__schedule-time">
								<LoaderBar height={7} width={40} />
							</div>
							<div className="itinerary-recap-timeline__schedule-date">
								<LoaderBar height={7} width={60} />
							</div>
						</div>
					</div>

					<div className="itinerary-recap-timeline__info-line--loader">
						<LoaderBar height={8} />
					</div>

					<div className="itinerary-recap-timeline__group" key="2">
						<div className="itinerary-recap-timeline__schedule">
							<div className="itinerary-recap-timeline__schedule-airport">
								<LoaderBar height={9} width={60} />
							</div>
							<div className="itinerary-recap-timeline__schedule-time">
								<LoaderBar height={7} width={40} />
							</div>
							<div className="itinerary-recap-timeline__schedule-date">
								<LoaderBar height={7} width={60} />
							</div>
						</div>
					</div>
				</div>
			)}
			{isDataReady && !isEmpty(groupedFlightData) && (
				<div className="itinerary-view-recap__itinerary--timeline">
					{groupedFlightData.map((group, index) => {
						if (
							group.length === 1 &&
							group[0].type === ITINERARY_INFO_TYPE.STOPOVER_INFO
						) {
							return <TimelineInfoRecap event={group[0]} key={index} />;
						}
						return (
							<div key={index} className="itinerary-recap-timeline__group">
								{group.map((event, eventIndex) => (
									<TimelineInfoRecap event={event} key={eventIndex} />
								))}
							</div>
						);
					})}
				</div>
			)}
		</div>
	);
};

ItineraryViewRecap.propTypes = {
	label: PropTypes.string,
	flightData: PropTypes.array,
};
export default memo(ItineraryViewRecap);
